import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';
import { getPhone } from './getPhone';

const LINK_PATTERN =
  /(https?:\/\/)?([\w.-]+)\.([\w.]{2,6})(([\w\-._~:/?#[\]@!$&'()*+,;=]|(%[0-9a-fA-F]{2}))*)\/?$/;

const getLink = (str: string) => {
  if (LINK_PATTERN.test(str)) {
    return str.startsWith('http') ? str : `https://${str}`;
  }

  return `https://wa.me/${getPhone(str)}`;
};

export const getWhatsAppSettings = ({
  whatsappPhone
}: Partial<ChatsChannelBase>) => {
  if (!whatsappPhone) return null;

  const whatsappValue = whatsappPhone.trim();

  return {
    provider: ChatsChannelType.whatsapp,
    link: { url: getLink(whatsappValue) },
    title: 'WhatsApp',
    icon: getChatIcon(ChatsChannelType.whatsapp),
    color: 'rgb(37, 211, 102)'
  } as ChatsChannelSetting;
};
